import { render, staticRenderFns } from "./prinTypeMng.vue?vue&type=template&id=1dbbad54&scoped=true"
import script from "./prinTypeMng.vue?vue&type=script&lang=js"
export * from "./prinTypeMng.vue?vue&type=script&lang=js"
import style0 from "./prinTypeMng.vue?vue&type=style&index=0&id=1dbbad54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbbad54",
  null
  
)

export default component.exports